import { all, call } from 'redux-saga/effects';
import adminUserSaga from './adminUser.saga';
import publicDataSaga from './publicData.saga';
import trafficStatusMap from './trafficStatusMap.saga';
import adminConfigSaga from './adminConfig.saga';

export default function* rootSaga() {
  yield all([
    call(adminUserSaga),
    call(publicDataSaga),
    call(trafficStatusMap),
    call(adminConfigSaga),
  ]);
}
